import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Navbar = () => {
  return (
    <>
      <nav className="navbar">
        <Link to="/" className="navbar-brand">
          Status Saver
        </Link>
        <div className="navbar-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
